import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from './../context/UserContext';

export const AuthNavigator = ({ children }) => {
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const initialNavigationDone = useRef(false);
    const isIntentionalNavigation = useRef(false);

    useEffect(() => {
        console.log('AuthNavigator: Effect triggered');
        console.log('Current user state:', user);
        console.log('Current location:', location.pathname);
        console.log('initialNavigationDone:', initialNavigationDone.current);
        console.log('isIntentionalNavigation:', isIntentionalNavigation.current);

        if (user.justLoggedOut) {
            console.log('User just logged out, navigating to login');
            initialNavigationDone.current = false;
            setUser(prevUser => ({ ...prevUser, justLoggedOut: false }));
            navigate('/auth/login', { replace: true });
        } else if (!user.loading && !initialNavigationDone.current && !isIntentionalNavigation.current) {
            if (user.loggedIn) {
                let route = user.details?.role === 'child' ? '/child' : '/family';

                // Use stored path if available and it's not an auth route
                const lastPath = localStorage.getItem('lastPath');
                console.log('Last path from localStorage:', lastPath);

                if (lastPath && !lastPath.startsWith('/auth')) {
                    route = lastPath;
                }

                console.log('Determined route:', route);

                if (location.pathname !== route) {
                    console.log(`AuthNavigator: Navigating to ${route}`);
                    navigate(route, { replace: true });
                } else {
                    console.log('Current location matches determined route, no navigation needed');
                }
            } else if (!location.pathname.startsWith('/auth')) {
                console.log('User not logged in and not on auth route, navigating to login');
                navigate('/auth/login', { replace: true });
            }
            initialNavigationDone.current = true;
        } else {
            console.log('No navigation action taken');
        }

        // Reset the intentional navigation flag
        isIntentionalNavigation.current = false;
        console.log('Reset isIntentionalNavigation to false');
    }, [user, setUser, navigate, location.pathname]);

    // Listen for location changes
    useEffect(() => {
        console.log('Location changed to:', location.pathname);
        isIntentionalNavigation.current = true;
        console.log('Set isIntentionalNavigation to true');
        
        // Update lastPath in localStorage
        if (!location.pathname.startsWith('/auth') && user.loggedIn) {
            localStorage.setItem('lastPath', location.pathname);
            console.log('Updated lastPath in localStorage:', location.pathname);
        }
    }, [location, user.loggedIn]);

    return children;
};